<template>
    <!-- HRP智慧管理平台(ODR) -->
    <productSchema :config="config"></productSchema>
</template>

<script>
import { config } from './js/hpr_system'
import productSchema from '../common/product_schema.vue'
export default {
    name: '',
    components: { productSchema },
    data() {
        return {
            config: config,
        };
    },
    computed: {
    },
    watch: {
    },
    methods: {

    },
};
</script>

<style scoped lang="less">
.odr {}
</style>
